import { useTheme } from '@mui/material/styles';

export const CopyIcon = () => {
    const theme = useTheme();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                d="M39.667 35H28.0003C26.7097 35 25.667 33.9573 25.667 32.6667V14C25.667 12.7094 26.7097 11.6667 28.0003 11.6667H35.8826C36.1889 11.6667 36.4878 11.7906 36.7066 12.0094L41.6576 16.9604C41.8764 17.1792 42.0003 17.4781 42.0003 17.7844V32.6667C42.0003 33.9573 40.9576 35 39.667 35ZM43.3055 15.3052L38.3618 10.3615C37.7055 9.70522 36.816 9.33334 35.8899 9.33334H28.0003C25.4264 9.33334 23.3337 11.4261 23.3337 14V32.6667C23.3337 35.2406 25.4264 37.3333 28.0003 37.3333H39.667C42.241 37.3333 44.3337 35.2406 44.3337 32.6667V17.7844C44.3337 16.8583 43.9618 15.9688 43.3055 15.3125V15.3052ZM16.3337 18.6667C13.7597 18.6667 11.667 20.7594 11.667 23.3333V42C11.667 44.574 13.7597 46.6667 16.3337 46.6667H28.0003C30.5743 46.6667 32.667 44.574 32.667 42V39.6667H30.3337V42C30.3337 43.2906 29.291 44.3333 28.0003 44.3333H16.3337C15.043 44.3333 14.0003 43.2906 14.0003 42V23.3333C14.0003 22.0427 15.043 21 16.3337 21H21.0003V18.6667H16.3337Z"
                fill={theme.colors.other.icon.stroke.primary}
            />
        </svg>
    );
};
